// 中文语言包
const lang = {};
export default lang;
